module.exports = __webpack_public_path__ + "static/media/calendar-ticket.7af8a4e5.svg";